module.exports = __webpack_public_path__ + "img/partner_abu.f6f41643.svg";